import React from 'react';
import styled from 'styled-components';
import { Flex } from '../shared/Flex';

const Wrapper = styled(Flex)`
  position: absolute;
  top: 0;
  height: auto;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 1);
  padding: 10px 20px;
  box-sizing: border-box;
  z-index: 9999;
`;

const Message = styled.div`
  padding: 0 20px 0 10px;
  font-size: 14px;
  color: #d84242;
  text-align: center;
`;

const InfoAlert = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <Wrapper>
      <Message>{message}</Message>
    </Wrapper>
  );
};
export default InfoAlert;
